import React, { useContext } from "react";
import { NotificationTypes } from "../config";
import { NotificationContext } from "../NotificationContext";
import "./NotificationSubNav.scss";

const NotificationSubNav = (props) => {
  const { navCounts } = props;
  const {
    activeNotificationNav,
    setNotificationNavResetTab,
    setLocalActiveNotificationNav,
  } = useContext(NotificationContext);
  const handleKeyDown = (e, type) => {
    if (e.which === 32) {
      setNotificationNavResetTab(type);
      setLocalActiveNotificationNav(type);
      e.preventDefault();
    }
  };
  return (
    <div className="header-container">
      <div className="header-content">
        <div className="grid-row">
          <div className="tablet:grid-col-6">
            <h3 className="usa-flag-page-header">Notification Center</h3>
            <p className="headerInfo">
              View and manage notifications throughout the application
              lifecycle.
            </p>
          </div>
          <div className="tablet:grid-col-6">
            <div className="notice"></div>
          </div>
        </div>

        <div className="grid-row">
          <div className="navigation tablet:grid-col-12">
            {NotificationTypes.map((type, index) => {
              return (
                <a
                  role="tab"
                  aria-controls={"notification_type_" + index}
                  tabindex={index + 1}
                  key={index}
                  onClick={() => {
                    setNotificationNavResetTab(type);
                    setLocalActiveNotificationNav(type);
                  }}
                  onKeyDown={(e) => handleKeyDown(e, type)}
                  className={
                    activeNotificationNav.machine_name === type.ui_name
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  {type.ui_name}
                  <button
                    disabled
                    className={
                      activeNotificationNav.machine_name === type.ui_name
                        ? "badge active"
                        : "badge"
                    }
                  >
                    <div className="badge-number">
                      {navCounts[type.ui_name]}
                    </div>
                  </button>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NotificationSubNav;
